export const SITE_URL = "https://www.medcompetente.it";

export const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80";

export const BUSINESS = {
  name: "BPMedLav — Studio di Medicina del Lavoro",
  shortName: "BPMedLav",
  legalName: "BPMedLav Studio di Medicina del Lavoro",
  description:
    "Studio di Medicina del Lavoro a Roma. Medici competenti per sorveglianza sanitaria, visite mediche in azienda, formazione primo soccorso e consulenza ai sensi del D.Lgs 81/08.",
  streetAddress: "Viale di Villa Pamphili, 99",
  postalCode: "00152",
  city: "Roma",
  region: "RM",
  country: "IT",
  email: "amministrazione@medcompetente.it",
  phone: null,
  geo: { lat: 41.8745, lng: 12.4397 },
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Viale+di+Villa+Pamphili+99+00152+Roma",
};

export const DOCTORS = [
  {
    id: "giuseppe-buomprisco",
    name: "Dr. Giuseppe Buomprisco",
    jobTitle: "Medico Competente — Specialista in Medicina del Lavoro",
    order: "Ordine dei Medici Chirurghi e Odontoiatri di Roma",
  },
  {
    id: "roberto-perri",
    name: "Dr. Roberto Perri",
    jobTitle: "Medico Competente — Specialista in Medicina del Lavoro",
    order: "Ordine dei Medici Chirurghi e Odontoiatri di Roma",
  },
];

export const STATS = [
  { value: "500+", label: "Aziende servite" },
  { value: "10.000+", label: "Visite effettuate" },
  { value: "10+", label: "Anni di esperienza" },
];

export const SERVICES = [
  {
    title: "Sorveglianza Sanitaria",
    lead: "Visite mediche preventive, periodiche, a richiesta e post-malattia per il rilascio del giudizio di idoneità alla mansione.",
    items: [
      "Visita preventiva",
      "Visita periodica",
      "Visita a richiesta del lavoratore",
      "Visita post-malattia e pre-demissione",
    ],
  },
  {
    title: "Accertamenti Sanitari",
    lead: "Esami strumentali e di laboratorio integrativi per una valutazione completa dello stato di salute del lavoratore.",
    items: [
      "Elettrocardiogramma (ECG)",
      "Spirometria",
      "Audiometria",
      "Drug test e alcol test",
      "Esami del sangue e delle urine",
    ],
  },
  {
    title: "Formazione Primo Soccorso",
    lead: "Corsi per addetti al primo soccorso aziendale secondo il DM 388/2003, con attestato valido ai fini di legge.",
    items: [
      "Gruppo A — 16 ore",
      "Gruppo B e C — 12 ore",
      "Aggiornamenti periodici",
    ],
  },
  {
    title: "Consulenza Aziendale",
    lead: "Supporto continuativo al datore di lavoro su tutte le tematiche sanitarie previste dal Testo Unico.",
    items: [
      "Collaborazione al Documento di Valutazione dei Rischi",
      "Sopralluoghi nei luoghi di lavoro",
      "Promozione della salute",
      "Supporto normativo D.Lgs 81/08",
    ],
  },
  {
    title: "Certificati INAIL — Malattia Professionale",
    lead: "Certificazione medica e assistenza nella denuncia delle malattie di origine professionale all'INAIL.",
    items: [
      "Certificato di malattia professionale",
      "Denuncia telematica all'INAIL",
      "Assistenza all'istruttoria",
      "Rivalutazioni e ricorsi",
    ],
  },
  {
    title: "Certificazioni INPS — Invalidità e Inabilità",
    lead: "Certificazioni medico-legali per invalidità civile e inabilità al lavoro ai fini previdenziali INPS.",
    items: [
      "Certificati di invalidità civile",
      "Inabilità al lavoro",
      "Documentazione sanitaria previdenziale",
      "Supporto completo alla pratica",
    ],
  },
];

export const FAQS = [
  {
    question: "Quando è obbligatorio nominare il medico competente?",
    answer:
      "La nomina del medico competente è obbligatoria quando i lavoratori sono esposti a rischi specifici: uso di videoterminali per più di 20 ore settimanali, movimentazione manuale dei carichi, rischio chimico, biologico, rumore, vibrazioni, lavoro notturno e altri rischi previsti dal D.Lgs 81/08. L'obbligo scatta dalla prima mansione a rischio presente in azienda.",
  },
  {
    question: "Cosa rischia il datore di lavoro senza medico competente?",
    answer:
      "La mancata nomina del medico competente è un reato: il datore di lavoro rischia l'arresto da 2 a 4 mesi o un'ammenda pecuniaria, oltre alla sospensione dell'attività in caso di violazioni gravi accertate dall'ASL. Anche la mancata effettuazione delle visite mediche obbligatorie è sanzionata penalmente.",
  },
  {
    question: "Quanto costa la sorveglianza sanitaria per un'azienda?",
    answer:
      "Il costo dipende dal numero di lavoratori, dalle mansioni e dai protocolli sanitari definiti dal medico competente. Per una piccola impresa a Roma si parte in genere da poche centinaia di euro l'anno. BPMedLav fornisce un preventivo gratuito via email in 24-48 ore, senza impegno.",
  },
  {
    question: "Quali tipi di visita medica prevede la sorveglianza sanitaria?",
    answer:
      "Il D.Lgs 81/08 prevede quattro tipi di visita: preventiva (prima dell'assegnazione alla mansione), periodica (di norma annuale), a richiesta del lavoratore (in presenza di motivazioni sanitarie) e in occasione del cambio di mansione o dopo un'assenza per malattia superiore a 60 giorni. Ogni visita si conclude con un giudizio di idoneità.",
  },
  {
    question: "Il medico competente può fare le visite direttamente in azienda?",
    answer:
      "Sì. Le visite mediche si svolgono preferibilmente presso l'ambulatorio aziendale o la sede dello studio. BPMedLav organizza le visite direttamente presso la vostra azienda a Roma quando il numero di lavoratori lo rende più efficiente, riducendo i tempi di fermo attività.",
  },
  {
    question: "Quanto tempo serve per mettersi in regola?",
    answer:
      "Dopo la nomina, il medico competente effettua un sopralluogo, definisce il protocollo sanitario e pianifica le prime visite entro pochi giorni. In genere un'azienda di piccole dimensioni completa il primo ciclo di sorveglianza sanitaria entro 2-4 settimane dalla nomina.",
  },
  {
    question: "Rilasciate certificati INAIL e certificazioni INPS?",
    answer:
      "Sì. BPMedLav redige il certificato medico di malattia professionale con invio telematico all'INAIL e assiste aziende e lavoratori nella denuncia e nell'istruttoria. Lo studio rilascia inoltre certificazioni medico-legali per invalidità civile e inabilità al lavoro ai fini INPS, curando la completezza della documentazione sanitaria.",
  },
  {
    question: "In quanto tempo si ottengono certificati e giudizi di idoneità?",
    answer:
      "Il giudizio di idoneità alla mansione viene rilasciato al termine della visita medica. Per le pratiche INAIL e INPS il certificato medico è emesso subito e inviato telematicamente: i tempi di risposta dipendono poi dagli istituti (istruttoria INAIL o visita accertativa INPS). Per la sorveglianza sanitaria completa, il primo ciclo di visite si conclude in genere entro 2-4 settimane dalla nomina.",
  },
];

export const CATEGORY_IMAGES = {
  "Sorveglianza Sanitaria":
    "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=900&q=80",
  Videoterminali:
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=900&q=80",
  Formazione:
    "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=900&q=80",
  Normativa:
    "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=900&q=80",
  Prevenzione:
    "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=900&q=80",
  Accertamenti:
    "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=900&q=80",
  Costi: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=900&q=80",
  INAIL: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=900&q=80",
  INPS: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=900&q=80",
};

export function categoryImage(category) {
  return CATEGORY_IMAGES[category] || CATEGORY_IMAGES["Prevenzione"];
}

export const MARQUEE_ITEMS = [
  "Sorveglianza Sanitaria",
  "D.Lgs 81/08",
  "Medico Competente Roma",
  "DM 388/2003",
  "Visite in Azienda",
  "Formazione Primo Soccorso",
  "Idoneità alla Mansione",
  "Valutazione dei Rischi",
];

const businessId = `${SITE_URL}/#business`;
const websiteId = `${SITE_URL}/#website`;

export function businessJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": ["MedicalBusiness", "LocalBusiness"],
    "@id": businessId,
    name: BUSINESS.name,
    alternateName: BUSINESS.shortName,
    description: BUSINESS.description,
    url: SITE_URL,
    email: BUSINESS.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: BUSINESS.streetAddress,
      postalCode: BUSINESS.postalCode,
      addressLocality: BUSINESS.city,
      addressRegion: BUSINESS.region,
      addressCountry: BUSINESS.country,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: BUSINESS.geo.lat,
      longitude: BUSINESS.geo.lng,
    },
    medicalSpecialty: "OccupationalMedicine",
    areaServed: { "@type": "City", name: "Roma" },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Servizi di medicina del lavoro",
      itemListElement: SERVICES.map((s, i) => ({
        "@type": "Offer",
        position: i + 1,
        itemOffered: { "@type": "Service", name: s.title, description: s.lead },
      })),
    },
    sameAs: [BUSINESS.mapsUrl],
    employee: DOCTORS.map((d) => ({ "@id": `${SITE_URL}/#${d.id}` })),
  };
}

export function physiciansJsonLd() {
  return DOCTORS.map((d) => ({
    "@context": "https://schema.org",
    "@type": "Physician",
    "@id": `${SITE_URL}/#${d.id}`,
    name: d.name,
    jobTitle: d.jobTitle,
    medicalSpecialty: "OccupationalMedicine",
    knowsAbout: [
      "Medicina del Lavoro",
      "Sorveglianza Sanitaria",
      "D.Lgs 81/08",
      "Primo Soccorso Aziendale",
    ],
    worksFor: { "@id": businessId },
    memberOf: {
      "@type": "Organization",
      name: d.order,
      sameAs: "https://www.omceo-roma.it",
    },
  }));
}

export function websiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": websiteId,
    url: SITE_URL,
    name: BUSINESS.shortName,
    inLanguage: "it-IT",
    publisher: { "@id": businessId },
  };
}

export function webPageJsonLd({ path, title, description }) {
  const url = `${SITE_URL}${path}`;
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${url}#webpage`,
    url,
    name: title,
    description,
    inLanguage: "it-IT",
    isPartOf: { "@id": websiteId },
    about: { "@id": businessId },
  };
}

export function faqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "@id": `${SITE_URL}/#faq`,
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
}

export function articleJsonLd(post) {
  const url = `${SITE_URL}/blog/${post.slug}`;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `${url}#article`,
    headline: post.title,
    description: post.description,
    inLanguage: "it-IT",
    datePublished: post.datePublished,
    dateModified: post.dateModified,
    mainEntityOfPage: url,
    author: { "@id": `${SITE_URL}/#${post.authorId}` },
    publisher: { "@id": businessId },
    about: { "@id": businessId },
  };
}

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}
